module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/btn_2_pc_6bce328210d8b6b5dbcb8db47db9c5e9.png";